module.exports = __webpack_public_path__ + "static/media/background_choose_language.889e5bb9.png";